import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Navigate } from "react-router";
import { Button, TextField, Alert, CircularProgress, Box, Typography, Stack } from '@mui/material';
import { AuthContext } from "../Auth/Auth";
import Logger from '../Logger/Logger';

const Parse = require('parse');
const Login = () => {
  const { currentUser, setCurrentUser } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [warning, setWarning] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });
  let navigate = useNavigate();

  useEffect(() => {
    var current = Parse.User.current();

    if (current) {
      if (current.get('emailVerified') === true) {
        setCurrentUser(current)
        Logger.LogLogin(current);
        navigate("/");
      }
    }
  }, [navigate, setCurrentUser]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setWarning("");
    
    try {
      const user = await Parse.User.logIn(formData.email, formData.password);
      if (user.get('emailVerified') === true) {
        Logger.LogLogin(user);
        setCurrentUser(user);
        navigate("/");
      } else {
        setWarning("User not activated yet!");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }

  const register = () => {
    const user = new Parse.User();
    let re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(formData.email)) {
      user.set("username", formData.email);
      user.set("password", formData.password);
      user.set("email", formData.email);
      user.signUp().then(() => {
        setWarning("Registration succesfull, account has to be activated by Sweco before you can login!");
      }, (error) => {
        console.log(error);
        setError(error.message);
      })
    } else {
      setWarning("To register enter an valid email adress and password");
    }
  }

  if (currentUser && currentUser.get('emailVerified')) {
    return <Navigate to="/" />;
  }

  const forgotPassword = () => {
    Parse.User.requestPasswordReset(formData.email)
      .then(() => {
        console.log("password reset mail send")
        // Password reset request was sent successfully
      }).catch((error) => {
        // Show the error message somewhere
        alert("Error: " + error.code + " " + error.message);
      });
  }

  return (
    <Box className="loginForm" component="form" onSubmit={handleLogin} sx={{ maxWidth: 400, mx: 'auto', p: 2 }}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {warning && <Alert severity="warning" sx={{ mb: 2 }}>{warning}</Alert>}

      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1" component="label" htmlFor="email">
          Email
        </Typography>
        <TextField
          id="email"
          name="email"
          type="email"
          fullWidth
          variant="outlined"
          placeholder="Enter email"
          value={formData.email}
          onChange={handleChange}
          margin="dense"
        />
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle1" component="label" htmlFor="password">
          Wachtwoord
        </Typography>
        <TextField
          id="password"
          name="password"
          type="password"
          fullWidth
          variant="outlined"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          margin="dense"
        />
      </Box>

      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Button 
          variant="contained" 
          type="submit" 
          disabled={loading}
        >
          {loading ? (
            <>
              <CircularProgress size={24} sx={{ mr: 1 }} color="inherit" />
              Loading...
            </>
          ) : 'Login'}
        </Button>
        <Button 
          variant="contained" 
          type="button" 
          onClick={register} 
          disabled={loading}
        >
          Registreren
        </Button>
        <Button 
          variant="contained" 
          type="button" 
          onClick={forgotPassword} 
          disabled={loading}
        >
          Password reset
        </Button>
      </Stack>
    </Box>
  );
};

export default Login;